import {
  type EthSendTransactionParams,
  type PersonalSignRequestParams,
  type TezosRequestParams,
} from "./type";

export const isTezosRequest = (
  params: TezosRequestParams | PersonalSignRequestParams | EthSendTransactionParams
): params is TezosRequestParams => {
  if (Array.isArray(params)) {
    return false;
  }

  const ethParams = params as EthSendTransactionParams;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ethParams.from !== undefined && ethParams.to !== undefined) {
    return false;
  }

  return true;
};
